import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-file-input-dialog',
  templateUrl: './file-input-dialog.component.html'
})
export class FileInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editFileInputForm: UntypedFormGroup;
  control: FieldConfigName;
  allowMultiple = this.constants.allowMultiple;
  allowedExtensions = this.constants.allowedExtensionsFile;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<FileInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }

  }

  ngOnInit(): void {
    this._initForm();
    this._initFormValues(this.control);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editFileInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editFileInputForm.value);
  }

  private _initForm(): void {
    this.editFileInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      accept: [[], []],
      multiple: [false]
    });
  }

  private _initFormValues(control: any): void {
    this.editFileInputForm.setValue({
      tooltip: control.options.tooltip,
      label: control.options.label,
      accept: control.options.accept,
      multiple: this.allowMultiple,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired
    });
  }
}
